import gql from 'graphql-tag'
import { main } from './fragments'

export default gql`
mutation updateProductGroup($id: ID!, $fields: ProductGroupInput!) {
	cashAssist {
		updateProductGroup(id: $id, fields: $fields) {
			...productGroupMain
		}
	}
}
${main}`
